import React from 'react';
import LegalLayout, { Section } from '../components/legal/LegalLayout';

export default function Privacy() {
  return (
    <LegalLayout title="Privacy Policy" effectiveDate="April 24, 2026" testId="privacy-page">
      <p>VelvetGate respects your privacy. This Privacy Policy explains what information we collect and how we use it.</p>

      <Section n="1" title="Information We Collect">
        <p>VelvetGate may collect:</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>Name</li>
          <li>Email address</li>
          <li>Phone number, if provided</li>
          <li>Event registration details</li>
          <li>Pass status and check-in activity</li>
          <li>Payment reference information, if provided by the Host or Guest</li>
          <li>Device/browser information for basic security and performance</li>
        </ul>
      </Section>

      <Section n="2" title="How We Use Information">
        <p>We use information to:</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>Create and manage event passes</li>
          <li>Send confirmations and event-related updates</li>
          <li>Provide access recovery, including magic links</li>
          <li>Help Hosts manage guest lists and check-in</li>
          <li>Improve platform reliability and security</li>
          <li>Respond to support requests</li>
        </ul>
      </Section>

      <Section n="3" title="Information Shared With Hosts">
        <p>When you register for an event, limited information may be shared with the event Host so they can manage access, approvals, payments, check-in, and guest communication.</p>
      </Section>

      <Section n="4" title="Payments">
        <p>VelvetGate may display or store payment method references or payment status information when provided by a Host or Guest.</p>
        <p>If payment is handled by a third-party provider, that provider’s own privacy policy and terms may apply.</p>
      </Section>

      <Section n="5" title="Data Selling">
        <p>VelvetGate does not sell personal information.</p>
      </Section>

      <Section n="6" title="Communications">
        <p>By using VelvetGate, you may receive event-related emails or messages, including confirmations, access updates, recovery links, approval notices, revocation notices, or important event updates.</p>
      </Section>

      <Section n="7" title="Security">
        <p>We use reasonable measures to protect information, but no system is completely secure. Users should avoid sharing pass links or codes with unauthorized people.</p>
      </Section>

      <Section n="8" title="Data Retention">
        <p>We may retain event and pass information as needed for platform operation, recordkeeping, security, dispute handling, and legal compliance.</p>
      </Section>

      <Section n="9" title="Your Choices">
        <p>You may request help with:</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>Updating incorrect information</li>
          <li>Deleting certain information</li>
          <li>Questions about your data</li>
        </ul>
        <p>Some information may need to be retained for legitimate platform, security, or legal reasons.</p>
      </Section>

      <Section n="10" title="Contact">
        <p>For privacy questions, contact: <a href="mailto:admin@velvetgatepass.com" className="text-[#D4AF37] hover:underline">admin@velvetgatepass.com</a></p>
      </Section>
    </LegalLayout>
  );
}
